import api from './api';

// Saved (editable) custom reports — persistence is fully decoupled from the
// employees' recorded hours; saving only stores an edited snapshot.
export const listCustomReports = (projectId) =>
    api.get(`/CustomReport/project/${projectId}`).then(r => r.data);

export const getCustomReport = (reportId) =>
    api.get(`/CustomReport/${reportId}`).then(r => r.data);

export const saveCustomReport = (projectId, payload) =>
    api.post(`/CustomReport/${projectId}`, payload).then(r => r.data);

export const updateCustomReport = (reportId, payload) =>
    api.put(`/CustomReport/${reportId}`, payload).then(r => r.data);

export const deleteCustomReport = (reportId) =>
    api.delete(`/CustomReport/${reportId}`).then(r => r.data);
